export type PushPermission = 'default' | 'granted' | 'denied' | 'unsupported'

export interface IRealtimeState {
  /** Whether this browser can receive web push at all. */
  supported: boolean
  /** Current notification permission (or 'unsupported'). */
  permission: PushPermission
  /** Whether the contextual "enable live updates" nudge is visible. */
  nudgeVisible: boolean
  /** Whether the FCM token has been registered + linked to a business. */
  registered: boolean
  /** This browser's stable device id, once known. */
  deviceId: string | null
}

export const RealtimeState: IRealtimeState = {
  supported: false,
  permission: 'default',
  nudgeVisible: false,
  registered: false,
  deviceId: null
}
